// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1e756aa9","455":"156ff1c1","977":"a9cb6b1a"}[chunkId] + ".chunk.js";
};